import getAxiosInstance from './'


export const addUser = (data) => {
    const axios = getAxiosInstance();
    return axios.post('/users', data)
}

export const inviteUser = (data) => {
    const axios = getAxiosInstance();
    return axios.post('/users/invitation', data)
}

export const completeProfile = (data) => {
    const axios = getAxiosInstance();
    return axios.put('/users/invitation', data)
}

export const createSupplierUser = (data) => {
  const axios = getAxiosInstance();
  return axios.post('users/invitation/create_supplier', data)
}

export const getUser = (invitation_token) => {
    const axios = getAxiosInstance();
    return axios({
        method: 'GET',
        url: `users/invitation/${invitation_token}`
    })
}

export const listUsers = (page, role_id, search, column, order, view = "web") => {
    const axios = getAxiosInstance();
    return axios({
        method: "GET",
        url: "/users",
        params: {
            page,
            role_id,
            user_details: search,
            column, order, view
        }
    })
}

export const getUserDetails = (id) => {
    const axios = getAxiosInstance();
    return axios({
        method: "GET",
        url: `/users/${id}`,
    })
}

export const editUser = (data, id) => {
    const axios = getAxiosInstance();
    return axios({
        method: "PUT",
        url: `/users/${id}`,
        data,
    })
}

export const resendInvitation = (id) => {
    const axios = getAxiosInstance();
    return axios({
        method: "PUT",
        url: `/users/${id}/resend_invitation`,
    })
}
export const outlookPasswordChange = (data) => {
    const axios = getAxiosInstance();
    return axios({
        method: "PUT",
        url: '/outlook_accounts/update_outlook_password',
        data,
    })
}

export const generateRoleToken = (id, role_id, token) => {
    const axios = getAxiosInstance(token, role_id);
    return axios.post(`/users/${id}/role_sessions`, {role_id: role_id})
}

export const removeUser = (id) => {
    const axios = getAxiosInstance();
    return axios({
        method: "DELETE",
        url: `users/${id}`,
    })
}